// @flow

/**
 * Displays a hero video.
 *
 * @author rbernard
 * @since Mar 2019
 */

import * as React from 'react';
import * as Import from '@ta/platform.import';
import type { VideoPlayerProps } from '@ta/media.video-player';
import type { VideoInfo } from './types';
import styles from './HeroVideo.less';

// Only send the video player to the client if its being used
const VideoPlayer = Import.component.onUsage<_, VideoPlayerProps>(
  () => import('@ta/media.video-player'),
  'VideoPlayer',
);

type Props = {
  /**
   * the video info
   */
  video: VideoInfo,
};

const HeroVideo = ({ video }: Props) => (
  <div className={styles.heroVideo}>
    <VideoPlayer
      source={video.sources[0].url}
      width="100%"
      height="100%"
      preload="auto"
      muted
      loop
      objectFitCover
      transparentBackground
      showControls={false}
      autopauseEnabled={false}
    />
  </div>
);
export default HeroVideo;
